import { useState, useRef } from "react";
import Config from "../../Config";


import PlTitle from "../../elements/PlTitle";
import InputPagger from "../../helpers/InputPagger";

import InputTextAlpha from "../../helpers/InputTextAlpha";
import InputCombo from "../../helpers/InputCombo";
import InputLegend from "../../helpers/InputLegend";

import InputComboRok from "../../helpers/InputComboRok";
import InputComboMiesiac from "../../helpers/InputComboMiesiac";


import Csv from "../../exporter/Csv";
import Print from "../../exporter/Print";
import HtmlToPDF from "../../exporter/HtmlToPDF";

import edit from "../../edit.png";
import trash from "../../trash.png";
import gin from "../../gin.png";
import gout from "../../gout.png";
 


import XTime from "../kids/XTime";
import InOutNew from "./InOutNew";
import InputComboDzien from "../../helpers/InputComboDzien";
import AppContext from "../../AppContext";
import MenuTable from "../../helpers/MenuTable";
import Xlsx from "../../exporter/Xlsx";



function InOut(props)
{

    const [refreshView, setRefreshView] = useState(props.userData.refreshView);

    const tabRef = useRef(0);
    const tab2Ref = useRef(0);


    const [filter, setFilter] = useState(null);
    const [filterParam, setFilterParam] = useState({
        p_imie_nazwisko: props.mainView.readFilter('p_imie_nazwisko',''),       
        archiwalny: '0',
        operacja: '_x_',
        rok: (new Date()).getFullYear() ,
        miesiac: (new Date() ).getMonth()+1,    
        dzien: '_x_',          
        limit: 50,
        page: 1,
        pages: 1,
        show: true,
    });
    const [tab, setTab] = useState(null);

    const [view, setView] = useState ( {
        v:'list',
        id: -1
    } );



    const [legend, setLegend] = useState([
        {
            cls:'color_show1',
            title: 'Wejście lub wyjście wirtualne - systemowe'
        },
    ]);



    const getTab = () => {
       
 
        props.mainView.setProgress(-2);

       

        fetch( Config.url + '/rest_v1_emps,inout', {
            method: 'POST', 
            body: JSON.stringify(filterParam), 
            headers: {
                'Content-Type': 'application/json',                    
                'X-Api-Key': props.userData.apiKey,
                '_p_przedszkole_id_': props.userData.p_przedszkole_id,
                '_p_dziecko_id_': props.userData.p_dziecko_id,
                '_sec_key_': Config.genXKey() ,
            }
         })
         .then(res => res.json() )
         .then(res => { 

                    props.mainView.setProgress(-1);        
                    if(res._sys_ == undefined)
                    {
                        props.mainView.showDialog( "Error", "No correct response from server" , "ok" , null);  
                    }else
                    if(res.status != undefined && res.status == 'ERROR'  && res.result != undefined )
                    {
                        props.mainView.showDialog( "Error", JSON.stringify(res.result) , "ok" , null);  
                    }else    
                    {
                        setTab(res.result);            
                        if(res.pages != undefined )setFilterParam( {...filterParam,   ['pages']: res.pages  } );             
                    }
         } )
         .catch(err => {          
                    props.mainView.showDialog( "Error", "I: " + err , "ok" , null);
                    props.mainView.setProgress(-1);
         });
                   

         return false;
    }

  

    const valChangeListener = (filedName, val, correct, msg) => {

       // console.log("valChangeListener: " + filedName + " " + val + ", correct: " + correct + ", msg: " + msg);

        setFilterParam( {...filterParam, [filedName]:val,  [filedName+"_valid"]:correct } );
        
        if(   (val.length == 0 || val.length > 2 || msg =='combo')  && filterParam[filedName] != val )
            {
                    var defTimeOut = 1000;
                    if(msg == 'combo') defTimeOut = 10;
                    clearTimeout(AppContext.timeoutId);
                    AppContext.timeoutId = setTimeout( () => {
                        setTab(null); 
                    } , defTimeOut );
            }

        props.mainView.writeFilter(filedName, val);
    }


    const goNextNew = () => {
        console.log("goNext");    
        setTab(null);    
    }

    const filterView = () => {
        setFilterParam(  {...filterParam, ["show"]:!filterParam.show } );
    }

    const filterClear = () => {
        setFilterParam({
            p_imie_nazwisko: '',               
            operacja: '_x_',
            rok: (new Date()).getFullYear() ,
            miesiac: (new Date() ).getMonth()+1,        
            dzien: '_x_',     
            limit: 50,
            page: 1,
            pages: 1,
            show:true, 
        });
        setTab(null);

        props.mainView.writeFilter('p_imie_nazwisko', '');
     
    }

    const filterApprove = () => {   
        setTab(null)     
    }

    const onChangePagger = (x_limit, x_page) => {

        setFilterParam(  {...filterParam, ["limit"]:x_limit, ["page"]:x_page} );
        setTab(null);
    }







    const goDeleteOK = (id) => {
       
 
        props.mainView.setProgress(-2);

        var req = {
            id:id
        };

        fetch( Config.url + '/rest_v1_emps,inout_remove', {
            method: 'POST', 
            body: JSON.stringify(req), 
            headers: {
                'Content-Type': 'application/json',                    
                'X-Api-Key': props.userData.apiKey,
                '_p_przedszkole_id_': props.userData.p_przedszkole_id,
                '_p_dziecko_id_': props.userData.p_dziecko_id,
                '_sec_key_': Config.genXKey() ,
            }
         })
         .then(res => res.json() )
         .then(res => { 

                    props.mainView.setProgress(-1);        
                    if(res._sys_ == undefined)
                    {
                        props.mainView.showDialog( "Error", "No correct response from server" , "ok" , null);  
                    }else
                    if(res.status != undefined && res.status == 'ERROR'  && res.result != undefined )
                    {
                        props.mainView.showDialog( "Error", JSON.stringify(res.result) , "ok" , null);  
                    }else    
                    {
                       props.mainView.showDialog( "Sukces",  "Pozycja została usunięta" , "ok" , null);  
                       getTab();  
                    }
         } )
         .catch(err => {          
                    props.mainView.showDialog( "Error", "I: " + err , "ok" , null);
                    props.mainView.setProgress(-1);
         });
                   

         return false;
    }



    const goDelete = (e) => {

        var id = e.target.getAttribute("id");

        props.mainView.showDialog("Potwierdź", "Czy na pewno chcesz usunąć wybraną pozycje?", "yesno", (option)=>{
          
                        ///--------
                        if(option == "yes") goDeleteOK(id);
                        //--------
        } );
    }





//param1={row.id} param2={row.dzien}  param3='' param4=''
    const onChangeXTime = (hm, param1, param2, param3, param4) =>  {

        console.log("XTime ", hm, param1, param2, param3, param4);


        props.mainView.setProgress(-2);

       
        var req = {
            p_rejestr_id: param1,
            dzien: param2,
            hm: hm,            
        };


        fetch( Config.url + '/rest_v1_emps,inout_update', {
            method: 'POST', 
            body: JSON.stringify(req), 
            headers: {
                'Content-Type': 'application/json',                    
                'X-Api-Key': props.userData.apiKey,
                '_p_przedszkole_id_': props.userData.p_przedszkole_id,
                '_p_dziecko_id_': props.userData.p_dziecko_id,
                '_sec_key_': Config.genXKey() ,
            }
         })
         .then(res => res.json() )
         .then(res => { 

                    props.mainView.setProgress(-1);        
                    if(res._sys_ == undefined)
                    {
                        props.mainView.showDialog( "Error", "No correct response from server" , "ok" , null);  
                    }else
                    if(res.status != undefined && res.status == 'ERROR'  && res.result != undefined )
                    {
                        props.mainView.showDialog( "Error", JSON.stringify(res.result) , "ok" , null);  
                    }else    
                    {
                        props.mainView.showDialog( "Sukces",  "Zmiany zostały zapisane" , "ok" , null );
                    }
         } )
         .catch(err => {          
                    props.mainView.showDialog( "Error", "I: " + err , "ok" , null);
                    props.mainView.setProgress(-1);
         });


    }



    
    if(tab == null)
        {
            setTab([]);
            getTab();
         
    
            return <div>
                ...
            </div>
        }
    
    
        if(refreshView != props.userData.refreshView)
        {         
            setRefreshView( props.userData.refreshView);
            setTab(null);
            setView( {
                v:'list',
                id: -1
            });
        }



    var operacjaItem = [
        {
            v: '_x_',
            title: '- - -'
        },
        {
            v: 'I',
            title: 'Wejście'
        },
        {
            v: 'O',
            title: 'Wyjście'
        },
    ];


    return (

        <div className="view_content">
         

                {
                    filterParam.show == false  &&
                    <div className="  goright link_color" onClick={filterView}>
                        pokaż filtry
                    </div>
                } 


                {
                    filterParam.show == true  &&
                    <div className="table_filter">

                     <div className="filter_controll">   
                            <label>Archiwalny: </label>                             
                            <InputCombo  items={ [ {v: '_x_', title:'- - - '}, {v: '0', title:'Nie'}, {v: '1', title:'Tak'},   ] }  userData={props.userData}  mainView={props.mainView}  value={filterParam.archiwalny}   valChange={valChangeListener} goNext={goNextNew} name="archiwalny" placeholder={": "}  noempty="1"   />
                        </div> 
               
    
                    <div className="filter_controll">   
                        <label>Pracownik: </label>                             
                        <InputTextAlpha   userData={props.userData} value={filterParam.p_imie_nazwisko}   valChange={valChangeListener} goNext={goNextNew} name="p_imie_nazwisko" placeholder={"Pracownik: "}   />
                    </div>  
     



                    <div className="filter_controll">   
                            <label>Rok: </label>                             
                            <InputComboRok   userData={props.userData}  mainView={props.mainView}  value={filterParam.rok}   valChange={valChangeListener} goNext={goNextNew} name="rok" placeholder={": "}  noempty="1"   />
                    </div> 
    
                    <div className="filter_controll">   
                            <label>Miesiąc: </label>                             
                            <InputComboMiesiac   userData={props.userData}  mainView={props.mainView}  value={filterParam.miesiac}   valChange={valChangeListener} goNext={goNextNew} name="miesiac" placeholder={": "}  noempty="1"   />
                    </div>
    
                    <div className="filter_controll">   
                            <label>Dzień: </label>                             
                            <InputComboDzien   userData={props.userData}  mainView={props.mainView}  rok={filterParam.rok}  miesiac={filterParam.miesiac}  value={filterParam.dzien}   valChange={valChangeListener} goNext={goNextNew} name="dzien" placeholder={": "}  noempty="0"   />
                    </div>
    
                    <div className="filter_controll">   
                            <label>Typ: </label>                             
                            <InputCombo   userData={props.userData}  mainView={props.mainView}  items={operacjaItem} value={filterParam.operacja}   valChange={valChangeListener} goNext={goNextNew} name="operacja" placeholder={": "}  noempty="1"   />
                    </div>
    
    
                  
    
                    <div className="filter_btn">
                                    <span className="link_color" onClick={filterView}>&nbsp;ukryj filtry&nbsp;</span> 
                                    <span className="btn" onClick={filterApprove} >filtruj</span>&nbsp;&nbsp;<span className="btn" onClick={filterClear} >wyczyść</span>
                    </div>
    
                </div>
                } 


           



            <div className="table_widget">
                            

                             <InOutNew userData={props.userData} mainView={props.mainView}  onSuccess={getTab} />

                             

                              <InputPagger filter={filterParam}  onChange={onChangePagger}  />
                                
                              <InputLegend items={legend}/>

                              &nbsp;&nbsp;                              

                              <HtmlToPDF tabRef={tabRef} userData={props.userData} mainView={props.mainView}  orientation="landscape" title="Rejestr" />   

                              <Csv tabRef={tab2Ref} title={"Wejścia i wyjścia," + filterParam.rok + "-" + filterParam.miesiac + ".csv"} />
                              <Xlsx tabRef={tab2Ref} title={"Wejścia i wyjścia," + filterParam.rok + "-" + filterParam.miesiac + ".xlsx" } />
                  
                             <Print tabRef={tab2Ref} />
            </div>




            <div className="bg_center">


 
 

                            <div ref={tabRef} className="gohide">

                                    <h3>Rejestr {filterParam.rok + "-" + filterParam.miesiac }</h3>   

                                    <table className="table" ref={tab2Ref} >
                                                <thead>
                                                    <tr className="header">
                                                        <td>LP</td>                                                 
                                                        <td>Pracownik</td>    
                                                        <td>Typ</td>                                   
                                                        <td>Dzień</td> 
                                                        <td>Godzina</td> 
                                                        <td>Źródło / Karta / Osoba</td>
                                                    
                                                    </tr>
                                                </thead>


                                                <tbody>
                                                                {
                                                                    tab.map( (row, ix)=>{

                                                                     
                                                                        var opTxt   = "Wejście";

                                                                        if(row.operacja == 'O') 
                                                                            {
                                                                            opTxt = "Wyjście";
                                                                           
                                                                            }


                                                                        var cls = "";
                                                                        if(row.autododanie == '1') cls = "color_show1";

                                                                        var sp = row.godzina.split(":");

                                                                        var rowStyle = " row ";
                                                                        if(ix % 2 == 0 )rowStyle = " row2 ";


                                                                        return <tr className={ rowStyle + cls}>
                                                                            <td className="gocenter">{ix+1}</td>
                                                                            <td>{row.nazwisko + " " + row.imie}</td>
                                                                            <td className="gocenter">{opTxt}  </td>
                                                                            <td className="gocenter">{row.dzien}</td>
                                                                            <td className="gocenter link_normal">
                                                                                {row.godzina}
                                                                            </td>
                                                                            <td>{row.src.info}</td>
                                                                  
                                                                        </tr>
                                                                    } )
                                                                }    
                                                </tbody>
                                                
                                   </table>
                            </div>

                        <div className="scorll_x">
                            <table className="table" >
                                <thead>
                                    <tr className="header">
                                        <td className="td_left">LP</td>                                                 
                                        <td>Pracownik</td>    
                                        <td>Typ</td>                                   
                                        <td>Dzień</td> 
                                        <td>Godzina</td> 
                                        <td className="td_right">Źródło / Karta / Osoba</td>
                                        <td className="td_option"> </td>
                                    </tr>
                                </thead>


                                <tbody>
                                                {
                                                    tab.map( (row, ix)=>{

                                                        var imgType = <img className="ibtn" src={gin} title="wejście"   />;
                                                        var opTxt   = "Wejście";

                                                        if(row.operacja == 'O') 
                                                            {
                                                               opTxt = "Wyjście";
                                                               imgType = <img className="ibtn" src={gout} title="wyjście"   />;
                                                            }


                                                        var cls = "";
                                                        if(row.autododanie == '1') cls = "color_show1";

                                                        var sp = row.godzina.split(":");

                                                        var rowStyle = " row ";
                                                        if(ix % 2 == 0 )rowStyle = " row2 ";


                                                        return <tr className={ rowStyle + cls}>
                                                            <td className="gocenter">{ix+1}</td>
                                                            <td>{row.nazwisko + " " + row.imie}</td>
                                                            <td className="gocenter">{opTxt} {imgType}</td>
                                                            <td className="gocenter">{row.dzien}</td>
                                                            <td className="gocenter link_normal">
                                                                 <XTime title={ row.imie + " " + row.nazwisko + " - " + row.dzien } hour={sp[0]} minute={sp[1]}  onChange={onChangeXTime} param1={row.id} param2={row.dzien}  param3='' param4='' />                                                                                     
                                                            </td>
                                                            <td>{row.src.info}</td>

                                                            <MenuTable>
                                                                        <ul>                                                                        
                                                                            <li onClick={goDelete} v="delete" id={row.id} >usuń</li>
                                                                        </ul>
                                                            </MenuTable>

                                                        </tr>
                                                    } )
                                                }    
                                </tbody>
                                
                            </table>
                        </div>
            </div>


        </div>
    )
}


export default InOut;